import axios from "axios";
import { userAccessToken } from "../helpers";
import { Config } from "../Config";


export const fetchAllNPIs = async (filter, account_id, location_id) => {
  const { search_term, order_by } = filter;
  let searchParam = search_term ? `&search_term=${search_term}` : "";
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";

  return await axios.get(`${Config.apiServerUrl}/practice-npi/all?account_id=${account_id}&location_id=${location_id}${searchParam}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const getNpiandInsurance = async (filter) => {
  const { account_id, location_id } = filter;

  return await axios.get(`${Config.patientServerUrl}/insurances/insurance-and-npi-mapping?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const searchNewNPI = async (data) => {
  const npi = String(data?.npi_number || "").trim();
  if (!/^\d{10}$/.test(npi)) {
    return { data: { status: "error", message: "Provide a valid 10-digit NPI number." } };
  }

  const base = `https://doc.pro/npi?npi=${encodeURIComponent(npi)}`;
  const targets = [base];

  for (const url of targets) {
    try {
      const r = await fetch(url, { method: "GET", cache: "no-store" });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const cms = await r.json();

      if (!cms?.result_count || !Array.isArray(cms.results) || !cms.results[0]) {
        return { data: { status: "error", message: "No NPI record found." } };
      }

      const basic = cms.results[0].basic || {};
      return {
        data: {
          status: "success",
          message: "NPI found.",
          npi_info: {
            organization_name: basic.organization_name || "",
            first_name: basic.first_name || "",
            last_name: basic.last_name || "",
          },
        },
      };
    } catch {}
  }

  return {
    data: {
      status: "error",
      message: "NPI registry request was blocked by CORS and no proxy is available. Use a backend proxy in production.",
    },
  };
};

export const addNewNPI = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/practice-npi/create`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateNPI = async (data) => {
  try {
    const response = await axios.put(`${Config.apiServerUrl}/practice-npi/update`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteNPI = async (id, account_id, location_id) => {
  try {
    const response = await axios.delete(`${Config.apiServerUrl}/practice-npi/delete/${id}?account_id=${account_id}&location_id=${location_id}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkEligibility = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/waiting-room/check-and-get-single-eligibility`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkClaim = async (data) => {
  try {
    const response = await axios.post(`${Config.apiServerUrl}/waiting-room/check-and-get-single-claim-status`, data, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addNewNpiManagement = async (formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/practice-npi/create-bulk`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addInsuranceNpi = async (formData) => {
  try {
    const response = axios.post(`${Config.apiServerUrl}/practice-npi/insurance-create-v2`, formData, {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const importClaims = async (data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    const response = await axios.post(`${Config.apiServerUrl}/waiting-room/bulk-upload-waiting-room-and-claim-status-xlsx`, formData,
      {
        responseType: "blob",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
